/**
 * Quartal-status API hooks.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { quartalKeys } from './keys';
import { useActiveTenantId } from '../../hooks/useTenantContext';

export interface QuartalRow {
  id: string;
  tenantId: string;
  year: number;
  quarter: number;
  status: 'open' | 'closed';
  closedAt: string | null;
  closedByUserId: string | null;
  reopenedAt: string | null;
}

export function useQuartals(year?: number) {
  const tenantId = useActiveTenantId();
  return useQuery({
    queryKey:
      year != null ? quartalKeys.year(tenantId, year) : quartalKeys.all(tenantId),
    queryFn: () =>
      api.get<{ items: QuartalRow[] }>(
        `/quartal-status${year ? `?year=${year}` : ''}`
      ),
    enabled: tenantId !== null,
  });
}

export function useCloseQuartal() {
  const qc = useQueryClient();
  const tenantId = useActiveTenantId();
  return useMutation({
    mutationFn: (input: { year: number; quarter: number }) =>
      api.post('/quartal-status/close', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: quartalKeys.all(tenantId) }),
  });
}

export function useReopenQuartal() {
  const qc = useQueryClient();
  const tenantId = useActiveTenantId();
  return useMutation({
    mutationFn: (input: { year: number; quarter: number }) =>
      api.post('/quartal-status/reopen', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: quartalKeys.all(tenantId) }),
  });
}
